"use client";
import { j as E } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as e } from "./tv.config-BuYIgndg.mjs";
import "react";
import { u as R } from "./useRender-DCcXqLqs.mjs";
import { m as C } from "./useRenderElement-B8V3_e8R.mjs";
const V = e({
  base: "",
  variants: {
    m: {
      xs: "m-2",
      sm: "m-4",
      md: "m-6",
      lg: "m-8",
      xl: "m-10",
      xxl: "m-12"
    },
    mx: {
      xs: "mx-2",
      sm: "mx-4",
      md: "mx-6",
      lg: "mx-8",
      xl: "mx-10",
      xxl: "mx-12",
      "mx-auto": "mx-auto"
    },
    my: {
      xs: "my-2",
      sm: "my-4",
      md: "my-6",
      lg: "my-8",
      xl: "my-10",
      xxl: "my-12"
    },
    ml: {
      xs: "ml-2",
      sm: "ml-4",
      md: "ml-6",
      lg: "ml-8",
      xl: "ml-10",
      xxl: "ml-12"
    },
    mr: {
      xs: "mr-2",
      sm: "mr-4",
      md: "mr-6",
      lg: "mr-8",
      xl: "mr-10",
      xxl: "mr-12"
    },
    mt: {
      xs: "mt-2",
      sm: "mt-4",
      md: "mt-6",
      lg: "mt-8",
      xl: "mt-10",
      xxl: "mt-12"
    },
    mb: {
      xs: "mb-2",
      sm: "mb-4",
      md: "mb-6",
      lg: "mb-8",
      xl: "mb-10",
      xxl: "mb-12"
    }
  }
});
e({
  base: "",
  variants: {
    xs: {
      true: "max-w-xs"
    },
    sm: {
      true: "max-w-sm"
    },
    md: {
      true: "max-w-md"
    },
    lg: {
      true: "max-w-lg"
    },
    xl: {
      true: "max-w-xl"
    },
    xxl: {
      true: "max-w-2xl"
    }
  },
  defaultVariants: {
    md: !0
  }
});
const B = e({
  extend: V,
  base: ["Box__root"],
  variants: {
    p: {
      sm: ["p-2"],
      md: ["p-4"],
      lg: ["p-6"]
    },
    bordered: {
      true: ["border"]
    },
    rounded: {
      true: ["rounded"]
    },
    flex: {
      true: ["flex"]
    },
    justifyContent: {
      center: ["justify-center"],
      flexStart: ["justify-start"],
      flexEnd: ["justify-end"],
      around: ["justify-around"],
      between: ["justify-between"],
      evenly: ["justify-evenly"]
    },
    alignItems: {
      center: ["items-center"],
      baseline: ["items-baseline"],
      flexStart: ["items-start"],
      flexEnd: ["items-end"],
      around: ["items-around"],
      between: ["items-between"],
      evenly: ["items-evenly"]
    },
    flexDirection: {
      row: ["flex-row"],
      col: ["flex-col"],
      rowRev: ["flex-row-reverse"],
      colRev: ["flex-col-reverse"]
    }
  },
  defaultVariants: {}
});
function h(m) {
  const {
    render: t,
    flex: r,
    flexDirection: s,
    justifyContent: l,
    alignItems: x,
    p: n,
    bordered: a,
    rounded: o,
    className: d,
    children: i,
    m: u,
    mb: f,
    ml: c,
    mr: b,
    mt: y,
    mx: p,
    my: g,
    ...w
  } = m, v = t ?? /* @__PURE__ */ E.jsx("div", {}), j = {
    children: i,
    className: B({
      flex: r,
      flexDirection: s,
      p: n,
      bordered: a,
      rounded: o,
      m: u,
      mb: f,
      ml: c,
      mr: b,
      mt: y,
      mx: p,
      my: g,
      justifyContent: l,
      alignItems: x,
      class: d
    })
  };
  return R({
    render: v,
    props: C(j, w)
  });
}
export {
  h as default
};
